/*
 * Constants
 ***************************/
 var $ = jQuery.noConflict()
 const mobileBreakpoint = parseInt(cat_10Vars.breakpoints.mobile_max);
 const navBreakpoint = parseInt(cat_10Vars.breakpoints.mobile_navigation_max);
 const windowResizeActions = [];
 let scrollTop = $(window).scrollTop(),
     navTrigger = 0;

 /*
  * Viewport height adjustments
  ***************************/
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
 // We execute the same script as before
 let vh = window.innerHeight * 0.01;
 document.documentElement.style.setProperty('--vh', `${vh}px`);
});

/*
 * Globals
 ***************************/
  /* Window */
    let windowWidth = $(window).width();
    let windowHeight = $(window).height();
    let windowScrollHeight = document.querySelector('body').scrollHeight;
  /* Breakpoints */
    let isMobile = ( windowWidth <= mobileBreakpoint );
    let isMobileNavigationActive = ( windowWidth <= navBreakpoint );
  /* Navigation */
    let isMenuOpen = false,
        isTakeoverMenuOpen = false,
        isSearchOpen = false;

  /* Ajax */
    let currentPage = 1;
    let ajaxIsLoading = false;
    let isDoneLoadingThings = false;
    let currentUrl = window.location.href;

  /* Slick Options */
    const prevArrow = '<button type="button" class="slick-big-arrow slick-prev"><span class="screen-reader-text">Previous</span></button>';
    const nextArrow = '<button type="button" class="slick-big-arrow slick-next"><span class="screen-reader-text">Next</span></button>';


const handleKeypressADA = function() {
  const keycode = (event.keyCode ? event.keyCode : event.which);
  if (keycode == '13') return;
  $(this).trigger('click');
};

const createPlyr = function(el, args) {
  if ( ! el || typeof window.Plyr !== 'function' ) {
    return null;
  }
  return new window.Plyr(el, args);
};

$(window).on('load', function() {
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
});

$(document).ready(function(){

  setTimeout( function() {
    replaceHeroBgImage();
  }, 10 );

  // Run on window resize.
  updateMenuClasses();

  const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  // Only register GSAP plugins that were actually enqueued for this page.
  const gsapPlugins = [];
  if ( typeof ScrollTrigger !== 'undefined' ) {
    gsapPlugins.push( ScrollTrigger );
  }
  if ( typeof Flip !== 'undefined' ) {
    gsapPlugins.push( Flip );
  }
  if ( typeof ScrollToPlugin !== 'undefined' ) {
    gsapPlugins.push( ScrollToPlugin );
  }
  if ( typeof SplitText !== 'undefined' ) {
    gsapPlugins.push( SplitText );
  }
  if ( gsapPlugins.length ) {
    gsap.registerPlugin( ...gsapPlugins );
  }

  /* Generic */
  if ( $('.modal-area').length ) {
    $('.modal-area').each(function(){
      const prop = $(this).data('propid');

      $(this).find('.modal-area__dismiss').on('click', function(){
        $(this).closest('.modal-area').removeClass('active');
        window.localStorage.setItem( prop, 'true' );
      }).on('keypress', handleKeypressADA);

      const element = $(this).get(0);

      $(this).on('click', function(e){
        if (e.target !== element && !element.contains(e.target)) {
          $(this).removeClass('active');
          window.localStorage.setItem( prop, 'true' );
        }
      });

      const modalDismissed = window.localStorage.getItem( prop );
      if ( modalDismissed != 'true' ) {
        const modal = $(this);
        setTimeout(function(){
          modal.addClass('active');
        }, $(this).data('delay'));
      }
    });
  }

  if ( $('.smooth-scroller').length ) { // internal links, smooth scrolling
    $('.smooth-scroller').on('click', function(e){
      e.preventDefault();
      let target = $( $(this).attr('href') ).offset().top - 148;
      let dist = Math.abs($(window).scrollTop() - target);

      $([document.documentElement, document.body]).animate({
        scrollTop: target
      }, Math.min(1200, ((dist / 1200) * 1000)));
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.copybutton').length ) {
    $('.copybutton').on('click', function(e){
      e.preventDefault();
      const targetEl = $( $(this).data('target') ).get(0);
      const alertEl = $( $(this).data('alert') ).get(0);
      targetEl.select()
      targetEl.setSelectionRange(0, 9999999);
      document.execCommand("copy");
      $(alertEl).fadeIn();
      setTimeout(function(){
        $(alertEl).fadeOut();
      }, 6000);
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modaltrigger').length ) {
    $('.modaltrigger').on('click', function(e){
      e.preventDefault();
      $(this).addClass('active');
      $(this).attr('aria-expanded', true );
      $($(this).attr('href')).addClass('active');
      $('#masthead').removeClass('scrolled-back');
      $('#masthead').addClass('scrolled');
      $('body').addClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modalclose').length ) {
    $('.modalclose').on('click', function(e){
      e.preventDefault();
      const controlledBy = $(this).data('controlledby');
      $(this).closest('.modal').removeClass('active');
      $(controlledBy).removeClass('active');
      $(controlledBy).attr('aria-expanded', false);
      $('body').removeClass('no-scroll');
    }).on('keypress', handleKeypressADA); 
  }
  if ( $('.copybutton').length ) {
    $('.copybutton').on('click', function(e){
      e.preventDefault();
      console.log('Copy Button Working');
      const targetEl = $( $(this).data('target') ).get(0);
      const alertEl = $( $(this).data('alert') ).get(0);
      targetEl.select()
      targetEl.setSelectionRange(0, 9999999);
      document.execCommand("copy");
      $(alertEl).fadeIn();
      setTimeout(function(){
        $(alertEl).fadeOut();
      }, 6000);
    }).on('keypress', handleKeypressADA);
  }
  /* END GENERIC SCRIPTS */

  /* NAVIGATION SCRIPTS */
  if ( $('.site-header__nav').length ) {
    const navResizeAction = (updated, navUpdated) => {
      if ( navUpdated ) {
        if ( isMobileNavigationActive ) {
          $('#site-nav').attr('role', 'dialog');
          $('#site-nav').attr('aria-modal', 'true');
        } else {
          const navEl = $('#site-nav').get(0);
          navEl.removeAttribute('role');
          navEl.removeAttribute('aria-modal');
        }
      }
    };

    navResizeAction(true, true);
    windowResizeActions.push(navResizeAction);

    const mobileNavContainer = $('.site-header__nav-inner');
    const mobileToggle = $('.site-header__nav-toggle');
    const mobileDismiss = $('.site-header__nav-dismiss');
    const firstFocusableMenuElement = $(mobileNavContainer).find('a, button, input').eq(0).get(0);
    const lastFocusableMenuElement = mobileDismiss.get(0);

    if ( $(mobileNavContainer).find('.menu-item-has-children') ) {
      $(mobileNavContainer).find('.menu-item-has-children').each(function(){
        const toggle = $(this).children('a, button');
        // console.log(toggle);
        const submenu = $(this).children('.sub-menu');
        const isThirdLevel = $(this).parent().hasClass('sub-menu');

        let target = $(toggle).attr('aria-controls');
        let expanded = $(toggle).attr('aria-expanded');

        const toggleResizeAction = (updated, navUpdated) => {
          if ( navUpdated ) {
            if ( isMobileNavigationActive || isThirdLevel ) {
              $(toggle).attr('aria-controls', target);
              $(toggle).attr('aria-expanded', expanded);
            } else {
              $(toggle).get(0).removeAttribute('aria-controls');
              $(toggle).get(0).removeAttribute('aria-expanded');
            }
          }
        };
        toggleResizeAction(true, true);

        toggle.on('click', function(){
          if ( isMobileNavigationActive || isThirdLevel ) {
            expanded = expanded == 'true' ? 'false' : 'true';
            $(toggle).attr('aria-expanded', expanded);
            submenu.slideToggle();
          }
        }).on('keypress', handleKeypressADA);
      });
    }

    $('.site-header__nav-toggle').on('click', function(){
      $(this).toggleClass('active');
      if ( $(this).hasClass('active') ) {
        $(mobileNavContainer).css({
          'visibility': 'visible',
          'pointer-events': 'auto'
        });
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
          onComplete: function(){
            $(mobileNavContainer).focus();
          }
        });
      } else {
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
          onComplete: function(){
            $('.site-header__nav-inner').css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });
      }
    }).on('keypress', handleKeypressADA);

    $(mobileDismiss).on('click', function(){
      if ( isMobileNavigationActive ) {
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
          onComplete: function(){
            $('.site-header__nav-inner').css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });

        $(mobileToggle).removeClass('active');
        $(mobileToggle).focus();
      }
    }).on('keypress', handleKeypressADA);

    $(mobileNavContainer).on('keydown', function(e){
      if ( isMobileNavigationActive ) {
        if ( e.key == 'Escape' ) {
          mobileDismiss.click();
        } else if(e.target == firstFocusableMenuElement && e.key == 'Tab' && e.shiftKey) {
          e.preventDefault();
          lastFocusableMenuElement.focus();
        } else if(e.target == lastFocusableMenuElement && e.key == 'Tab' && !e.shiftKey) {
          e.preventDefault();
          firstFocusableMenuElement.focus();
        }
      }
    });
    
    const searchModalOuter = $('.site-header__nav-search__modal');
    const searchModal = $('.site-header__nav-search__modal-inner');
    const searchToggle = $('.site-header__search-trigger');
    const searchDismiss = $('.site-header__nav-search__modal-dismiss');
    let searchModalIsAnimating = false;
    
    const closeModal = () => {
      searchModalIsAnimating = true;
      
      gsap.to(searchDismiss, {
        opacity: 0,
        duration: 0.8,
        ease: 'power3.inOut'
      });
      
      gsap.to(searchModal, {
        y: '-100%',
        duration: 0.8,
        ease: 'power3.inOut',
        onComplete: function() {
          $(searchModalOuter).css({
            'pointer-events': 'none',
            'visibility': 'hidden'
          })
          
          gsap.to('.site-header', {
            '--nav-border-radius': '5px' ,
            duration: 0.4
          });
          
          $(searchToggle).eq(0).focus();
          searchModalIsAnimating = false;
        }
      });
    }
    
    const openModal = () => {
      searchModalIsAnimating = true;
      $(searchModalOuter).css({
        'pointer-events': 'auto',
        'visibility': 'visible'
      });
      
      
      
      // gsap.to(searchModalOuter, {
      //   backgroundColor: 'rgba(244,245,246,0.7)',
      //   duration: 0.8,
      //   ease: 'power3.inOut'
      // });
      
      gsap.to(searchDismiss, {
        opacity: 1,
        duration: 0.8,
        ease: 'power3.inOut'
      });
      
      gsap.to('.site-header', {
        '--nav-border-radius': '0px',
        duration: 0.4
      });
      
      gsap.to(searchModal, {
        y: 0,
        duration: 0.8,
        ease: 'power3.inOut',
        onComplete: function() {
          searchModalIsAnimating = false;
        }
      });
    }
    
    $(searchToggle).on('click', function(){
      if ( isMobile ) {
        $('.site-header__nav-toggle').click();
      } else {
        console.log("helloooooo");
        if ( searchModalIsAnimating === false ) {
          $(searchToggle).toggleClass('active');
          if ( $(this).hasClass('active') ) {
            openModal();
          } else {
            closeModal();
          }
        }
      }
    });
    
    $('.site-header__nav-search__modal-dismiss').on('click', function(){
      searchToggle.removeClass('active');
      closeModal();
    });

    const dropdownList = $('.site-header__dropdown-list');
    const dropdownToggle = $('.site-header__dropdown-trigger');
    if ( dropdownList.length && dropdownToggle.length ) {
      $(dropdownToggle).on('click', function(){
        $(this).toggleClass('active');
        $(this).attr('aria-expanded',  $(this).attr('aria-expanded') === 'true' ? 'false' : 'true' );
        if ( $(this).hasClass('active') ) {
          $(dropdownList).css({
            'visibility': 'visible',
            'pointer-events': 'auto'
          });
          gsap.to(dropdownList, {
            duration: 0.67,
            ease: 'power3.inOut',
            clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
            onComplete: function(){
              $(dropdownList).find('a').eq(0).focus();
            }
          });
        } else {
          gsap.to(dropdownList, {
            duration: 0.67,
            ease: 'power3.inOut',
            clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
            onComplete: function(){
              $(dropdownList).css({
                'visibility': 'hidden',
                'pointer-events': 'none'
              });
            }
          });
        }
      }).on('keypress', handleKeypressADA);

      $(window).on('click', function(e){
        if ( $(dropdownToggle).hasClass('active') ) {
          if ( e.target !== dropdownToggle.get(0) && !dropdownToggle.get(0).contains(e.target) && e.target !== dropdownList.get(0) && !dropdownList.get(0).contains(e.target) ) {
            $(dropdownToggle).trigger('click');
          }
        }
      });
    }
  }
  
  // Update heights for top header and countdown banner using jQuery only
  const updateHeights = function() {
    var topHeaderHeight = $('.site-top-header').length > 0 ? $('.site-top-header').outerHeight() : 0;
    var countdownHeight = $('.site-countdown').length > 0 && !$('.site-countdown').hasClass('dismissed') ? $('.site-countdown').outerHeight() : 0;
    
    // Set CSS variables using jQuery
    $('body').css('--top-header-height', topHeaderHeight + 'px');
    $('html').css('--top-header-height', topHeaderHeight + 'px');
    $('body').css('--countdown-height', countdownHeight + 'px');
    $('html').css('--countdown-height', countdownHeight + 'px');
    
    // Also set using native method as additional fallback
    document.documentElement.style.setProperty('--top-header-height', topHeaderHeight + 'px');
    document.documentElement.style.setProperty('--countdown-height', countdownHeight + 'px');
    if ( document.body ) {
      document.body.style.setProperty('--top-header-height', topHeaderHeight + 'px');
      document.body.style.setProperty('--countdown-height', countdownHeight + 'px');
    }
  };
  
  // Initialize heights if top header or countdown exists
  if ( $('.site-top-header').length || $('.site-countdown').length ) {
    let timerTL = null;
    
    // Wait for elements to be fully rendered
    // setTimeout(function() {
      updateHeights();
    // }, 100);
    
    // Update on window resize
    $(window).on('resize', function(){
      updateHeights();
    });
    
    // Countdown dismiss handler
    if ( $('.site-countdown__dismiss').length ) {
      $('.site-countdown__dismiss').on('click', function(){
        const closeTL = gsap.timeline({
          repeat: false,
          onComplete: function() {
            if ( timerTL !== null ) {
              timerTL.pause();
            }
            $('.site-countdown').addClass('dismissed');
            updateHeights();
          }
        });
        
        closeTL.to('.site-countdown', {
          y: '-100%',
          duration: 0.6
        });
        
        // Set CSS variable using jQuery instead of GSAP
        $('body').css('--countdown-height', '0px');
        $('html').css('--countdown-height', '0px');
        document.documentElement.style.setProperty('--countdown-height', '0px');
        if ( document.body ) {
          document.body.style.setProperty('--countdown-height', '0px');
        }
      });
    }
    
    // Alert Banner scheduling functionality
    // Show/hide alert banner based on start/end dates
    if ( $('.site-top-header').length ) {
      const $alertBanner = $('.site-top-header');
      const startDate = $alertBanner.data('start-date');
      const endDate = $alertBanner.data('end-date');
      
      const checkAlertBannerSchedule = function() {
        const now = new Date();
        let shouldShow = true;
        
        // Check start date
        if ( startDate ) {
          const start = new Date( startDate );
          if ( now < start ) {
            shouldShow = false;
          }
        }
        
        // Check end date
        if ( endDate ) {
          const end = new Date( endDate );
          if ( now > end ) {
            shouldShow = false;
          }
        }
        
        // Show or hide banner
        if ( shouldShow ) {
          $alertBanner.slideDown(300);
          $('body').addClass('has-top-header');
        } else {
          $alertBanner.slideUp(300);
          $('body').removeClass('has-top-header');
        }
      };
      
      // Check immediately on page load
      checkAlertBannerSchedule();
      
      // Check every minute to handle schedule changes
      setInterval(checkAlertBannerSchedule, 60000);
      
      // Also check when start/end times are reached
      if ( startDate ) {
        const start = new Date( startDate );
        const timeUntilStart = start.getTime() - new Date().getTime();
        if ( timeUntilStart > 0 ) {
          setTimeout(checkAlertBannerSchedule, timeUntilStart);
        }
      }
      
      if ( endDate ) {
        const end = new Date( endDate );
        const timeUntilEnd = end.getTime() - new Date().getTime();
        if ( timeUntilEnd > 0 ) {
          setTimeout(checkAlertBannerSchedule, timeUntilEnd);
        }
      }
    }

    // Countdown banner scheduling — reveal when the start date is reached.
    if ( $('.site-countdown').length ) {
      const $countdown = $('.site-countdown');
      const countdownStartDate = $countdown.data('start-date');

      if ( countdownStartDate ) {
        const countdownStart = new Date( countdownStartDate );
        const timeUntilCountdownStart = countdownStart.getTime() - new Date().getTime();

        if ( timeUntilCountdownStart > 0 ) {
          $countdown.hide();
          $('body').removeClass('has-timer-countdown');
          updateHeights();

          setTimeout(function() {
            $countdown[0].style.removeProperty('display');
            $('body').addClass('has-timer-countdown');
            updateHeights();
          }, timeUntilCountdownStart);
        }
      }
    }
    
    // Countdown timer functionality
    if ( $('.site-countdown').length && !$('.site-countdown').hasClass('completed') && $('.site-countdown__inner-timer').length ) {
      const countdownTarget = $('.site-countdown__inner-timer').data('datetime');
      if ( countdownTarget ) {
        const dateFuture = new Date(countdownTarget);
        const getPeriod = () => {
          const dateNow = new Date();
          let diff = dateFuture - dateNow;
          
          if (diff < 0) diff = 0; // Prevent negative values

          const seconds = Math.floor((diff / 1000) % 60);
          const minutes = Math.floor((diff / 1000 / 60) % 60);
          const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
          const days = Math.floor(diff / (1000 * 60 * 60 * 24));

          if ( 0 == diff ) {
            $('.site-countdown__dismiss').trigger( 'click' );
          }
      
          return {
            days: days.toString().padStart(2, '0'),
            hours: hours.toString().padStart(2, '0'),
            minutes: minutes.toString().padStart(2, '0'),
            seconds: seconds.toString().padStart(2, '0'),
          };
        };
        
        timerTL = gsap.timeline({
          repeat: -1,
          onRepeat: function() {
            const parts = getPeriod();
            
            for ( const prop in parts ) {
              const target =  $('.site-countdown__inner-timer-section--num.' + prop);
              if ( $(target).text() != parts[prop] ) {
                $(target).text(parts[prop]);
              }
            }
          }
        });
        
        timerTL.to({x: 0}, {
          x: 1,
          duration: 1
        });
      }
    }
  }
  
  if ( $('.site-header__signup').length ) {
    const signup = $('#navigation-sf-form');
    const trigger = $('.site-header__signup-trigger');
    if ( typeof window.cmykpressSetupPopup === 'function' && signup.length ) {
      window.cmykpressSetupPopup( signup, false );
    }
    
    trigger.on('click', function(){
      if ( isMobileNavigationActive ) {
        $('.site-header__nav-toggle').trigger('click');
      }
      
      gsap.set(signup, {
        clearProps: 'opacity'
      });
      setTimeout(function(){
        $(signup).addClass('active');
      }, 50);
    });
  }
  
  if ( $('.site-badge').length ) {
    const badgeModal = $('#site-badge-modal');
    const trigger = $('.site-badge');
    if ( typeof window.cmykpressSetupPopup === 'function' && badgeModal.length ) {
      window.cmykpressSetupPopup( badgeModal, false );
    }
    
    trigger.on('click', function(){
      gsap.set(badgeModal, {
        clearProps: 'opacity'
      });
      
      setTimeout(function(){
        $(badgeModal).addClass('active');
      }, 50);
    });
  }
  /* END NAVIGATION SCRIPTS */

  /* GUTENBERG BLOCK SCRIPTS */
  // gallery
  if ( $('.header-hero.has-background-type-video').length ) {
    $('.header-hero.has-background-type-video').each(function(){
      if ( $(this).closest('.header-carousel').length === 0 ) {
        const video = $(this).find('.header-hero__background video, .header-hero__embed');
        const player = createPlyr(video.get(0), {
          controls: ['play', 'mute'],
          hideControls: false,
          autoplay: true,
          muted: true,
          playsinline: true,
          loop: {
            active: true
          }
        });
      }
    });
  }
  
  if ( $('.header-carousel').length ) {
    $('.header-carousel').each(function(){
      const container = $(this).find('.header-carousel__inner');
      const slides = $(this).find('.header-carousel__inner > *');
      const backgrounds = $(this).find('.header-carousel__backgrounds-inner');
      const arrContainer = $(this).find('.header-carousel__controls-arrs');
      const curNum = $(this).find('.header-carousel__controls-nums--cur');
      const totNum = $(this).find('.header-carousel__controls-nums--tot');
      const autoplayToggle = $(this).find('.header-carousel__controls-autoplaytoggle');
      let isAutoplaying = autoplayToggle.hasClass('playing');
      const autoplaySpeed = $(this).data('autoplayspeed');
      const splitTexts = {};
      const controlsContainer = $(this).find('.header-carousel__controls');
      
      totNum.text((( slides.length ) + '').padStart(2, '0'));
      
      slides.each(function(index) {
        if ( $(this).is('.header-hero') ) {
          const clone = $(this).find('.header-hero__background');
          clone.wrap('<div class="header-carousel__backgrounds-slide"></div>');
          backgrounds.append(clone.parent());
          
          const tosplit = $(this).find('.header-hero__content').find('p, h1, h2, h3, h4, h5, h6');
          
          const splits = gsap.timeline({
            paused: index === 0 ? false : true,
            repeat: false
          });
          tosplit.each(function(){
            const split = new SplitText(this, {
               type: 'lines,words',
               linesClass: 'split-line',
               wordsClass: 'split-word',
               tag: 'span'
             });
             gsap.set(split.words, {
               y: '100%',
               opacity: 0
             });
             
             splits.to(split.words, {
               y: '0%',
               duration: 0.3,
               opacity: 1,
               stagger: {
                 amount: Math.min(split.words.length * 0.08, 0.4),
                 ease: split.lines > 1 ? 'power2.in' : 'linear'
               }
             }, '>-0.15');
          });
          
          const ctas = $(this).find('.wp-block-button__link');
          ctas.each(function(){
            gsap.set(this, {
              y: '100%',
              opacity: 0
            });
            
            splits.to(this, {
              y: '0',
              opacity: 1,
              duration: 0.3
            }, '>-0.15');
          });
          
          splitTexts[index] = splits;
        }
      });
      
      const players = {
        
      };
      
      $(backgrounds).find('.header-hero__background').each(function(index){
        if ( $(this).is('.is-background-type-video') ) {
          const video = $(this).find('video, .header-hero__embed');
          const player = createPlyr(video.get(0), {
            controls: ['play-large', 'mute'],
            hideControls: false,
            autoplay: index === 1 ? true : false,
            muted: true,
            playsinline: true,
            loop: {
              active: true
            }
          });

          if ( player ) {
            players[index] = player;

            if ( index === 0 ) {
              player.play();
            }
          }
        }
      });
      
      
      backgrounds.on('init', function(){
        if ( players.hasOwnProperty(0) ) {
          players[0].play();
        }
      }).slick({
        fade: true,
        arrows: false
      });
      
      container.slick({
        swipe: false,
        appendArrows: arrContainer,
        asNavFor: backgrounds,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        fade: true
      });
      
      gsap.set(container, {
        '--header-controls-height': $(controlsContainer).outerHeight() + 'px'
      })
      
      $(window).on('resize', function(){
        gsap.set(container, {
          '--header-controls-height': $(controlsContainer).outerHeight() + 'px'
        })
      });
      
      const autoplayTL = gsap.timeline({
        repeat: -1,
        paused: !isAutoplaying,
        onRepeat: function() {
          $(container).slick('slickNext');
        }
      });
      
      $(container).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        curNum.text(((nextSlide + 1) + '').padStart(2, '0'));
        if ( players.hasOwnProperty(currentSlide) ) {
          players[currentSlide].pause();
        }
        
        if ( splitTexts.hasOwnProperty(currentSlide) ) {
          splitTexts[currentSlide].timeScale(3);
          splitTexts[currentSlide].reverse();
        }
        
        if ( isAutoplaying ) {
          autoplayTL.seek(0);
        }
      });
      
      $(container).on('afterChange', function(event, slick, currentSlide){
        if ( players.hasOwnProperty(currentSlide) ) {
          players[currentSlide].play();
        }
        
        if ( splitTexts.hasOwnProperty(currentSlide) ) {
          splitTexts[currentSlide].timeScale(1);
          splitTexts[currentSlide].play();
        }
      });
       
       
       
      autoplayTL.to($(this).find('.header-carousel__progress-per'), {
        scaleX: 1,
        ease: 'none',
        duration: autoplaySpeed
      });
      
      $(autoplayToggle).on('click', function(){
        isAutoplaying = !isAutoplaying;
        if ( isAutoplaying ) {
          $(autoplayToggle).removeClass('paused');
          $(autoplayToggle).addClass('playing');
          $(this).find('.screen-reader-text').text( $(this).data('pausetext') );
          autoplayTL.play();
          console.log(autoplayTL);
        } else {
          $(autoplayToggle).removeClass('playing');
          $(autoplayToggle).addClass('paused');
          $(this).find('.screen-reader-text').text( $(this).data('playtext') );
          autoplayTL.pause();
        }
      });
    });
  }
  
  if ( $('.wp-block-video, .wp-block-embed.is-provider-youtube, .wp-block-embed.is-provider-vimeo').length ) {
    $('.wp-block-video, .wp-block-embed.is-provider-youtube, .wp-block-embed.is-provider-vimeo').each(function(){
      const target = $(this).find('video, .wp-block-embed__wrapper');
      const el = target.get(0);
      
      const controls = ['play-large', 'progress', 'play', 'current-time', 'duration', 'mute', 'captions', 'fullscreen'];
      const shouldAutoplay = el.hasAttribute('autoplay') ? (el.getAttribute('autoplay') === 'true' || el.getAttribute('autoplay') === '') : false;
      
      const args = {
        autoplay: shouldAutoplay,
        controls: $(el).is('video') && el.hasAttribute('controls') ? ( el.getAttribute('controls') === 'false' ? [] : controls ) : ($(el).is('video') ? [] : controls),
        playsinline: el.hasAttribute('playsinline') ? (el.getAttribute('playsinline') === 'true' || el.getAttribute('playsinline') === '') : false,
        loop: el.hasAttribute('loop') ? ( (el.getAttribute('loop') === 'true' || el.getAttribute('loop') === '') ? {active: true} : {active: false}) : {active: false},
        muted: shouldAutoplay ? true : ( el.hasAttribute('muted') ? (el.getAttribute('muted') === 'true' || el.getAttribute('muted') === '') : false ),
        displayDuration: true,
        invertTime: false,
        iconUrl: cat_10Vars.svgSpritesheet,
      };
      
      const player = createPlyr(el, args);
    });
  }
  
  if ( $('.wp-block-audio').length ) {
    $('.wp-block-audio').each(function() {
      const target = $(this).find('audio');
      const el = target.get(0);
      
      const controls = ['play', 'current-time', 'duration', 'progress', 'mute', 'captions'];
      const shouldAutoplay = el.hasAttribute('autoplay') ? (el.getAttribute('autoplay') === 'true' || el.getAttribute('autoplay') === '') : false;
      
      const args = {
        autoplay: shouldAutoplay,
        loop: el.hasAttribute('loop') ? ( (el.getAttribute('loop') === 'true' || el.getAttribute('loop') === '') ? {active: true} : {active: false}) : {active: false},
        displayDuration: true,
        invertTime: false,
        iconUrl: cat_10Vars.svgSpritesheet
      };
      
      const player = createPlyr(el, args);
    });
  }
  
  if ( $('.wp-block-gallery').length ) {
    $('.wp-block-gallery').each(function(){
      gutenbergSlickify(this);
    });
  }

  const syncCardBlockCarousels = function() {
    $('.card-block.is-carousel').each(function(){
      const $block = $(this);
      const $grid = $block.children('.card-block__grid');
      const $track = $grid.children('.acf-innerblocks-container');

      if ( ! $track.length ) {
        return;
      }

      const desktopSlides = parseInt( $block.attr('data-slides'), 10 ) || 3;
      const $cards = $track.find('.card-inner').filter(function() {
        return $(this).closest('.slick-cloned').length === 0;
      });
      const imageOnly = $block.hasClass('is-image-carousel') || (
        $cards.length > 0 && $cards.toArray().every(function(card) {
          return $(card).find('.card-inner__header, .card-inner__body').length === 0;
        })
      );
      // Image-only carousels stay a slider on mobile. Cards with text still follow the Mobile slider setting.
      const mobileSlider = imageOnly || $block.attr('data-mobile-slider') !== '0';

      if ( imageOnly ) {
        $block.removeClass('is-mobile-stack').addClass('is-image-carousel');
      }

      const isInitialized = $track.hasClass('slick-initialized');
      const slideCount = isInitialized
        ? $track.find('.slick-slide:not(.slick-cloned)').length
        : $track.children().length;

      let visibleCount = desktopSlides;
      if ( windowWidth <= mobileBreakpoint ) {
        visibleCount = mobileSlider ? 1 : slideCount;
      } else if ( windowWidth <= navBreakpoint ) {
        visibleCount = Math.min( desktopSlides, 2 );
      }

      const needsSlider = slideCount > visibleCount;

      if ( ! needsSlider ) {
        if ( isInitialized ) {
          $track.slick('unslick');
        }
        $block.removeClass('has-slick');
        return;
      }

      if ( isInitialized ) {
        return;
      }

      $block.addClass('has-slick');
      $track.slick({
        slidesToShow: visibleCount,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: true,
        adaptiveHeight: false,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        appendArrows: $grid,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: Math.min( desktopSlides, 2 )
            }
          },
          {
            breakpoint: 768,
            settings: mobileSlider ? {
              slidesToShow: 1
            } : 'unslick'
          }
        ]
      });
    });
  };

  if ( $('.card-block.is-carousel').length ) {
    syncCardBlockCarousels();
    windowResizeActions.push(function(updated, navUpdated){
      if ( updated || navUpdated ) {
        syncCardBlockCarousels();
      }
    });
  }
  
  if ( $('.is-style-bottom-tear').length ) {
    const count = $('.is-style-bottom-tear').length;
    $('.is-style-bottom-tear').each(function(index){
      $(this).css({
        'z-index': (count + 1) - index
      })
    });
  }
  
  // dropdowns
  if ( $('.cat_10-dropdown').length ) {
    $('.cat_10-dropdown').each(function(){
      const toggle = $(this).find('.cat_10-dropdown__toggle');
      const wrapper = $(this).find('.cat_10-dropdown__inner');
      const dropdown = $(this).find('.cat_10-dropdown__dropdown');
      let isAnimating = false;
      
      $(dropdown).css({
        width: 'auto'
      });
      
      $(wrapper).css({
        'width': Math.round(dropdown.width() + 16) + 'px'
      });
      
      $(dropdown).css({
        width: '100%'
      });
      
      const openDropdown = (e) => {
        $(toggle).attr('aria-expanded', 'true');
        
        $(dropdown).css({
          'visibility': 'visible',
          'pointer-events': 'auto'
        });
        gsap.to(dropdown, {
          clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
          ease: 'power2.inOut',
          overwrite: true
        });
      };
      
      const closeDropdown = (e) => {
        $(toggle).attr('aria-expanded', 'false');
        
        gsap.to(dropdown, {
          clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
          ease: 'power2.inOut',
          overwrite: true,
          onComplete: function(){
            $(dropdown).css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });
      };
      
      toggle.on('click', function(e){        
        if ( $(this).attr('aria-expanded') == 'true' ) {
          closeDropdown(e);
        } else {
          openDropdown(e);
        }
      });
      
      if ( window.matchMedia('pointer: fine') ) {
        $(this).on('mouseenter', function(e){
          openDropdown(e);
        });
        
        $(this).on('mouseleave', function(e){
          closeDropdown(e);
        });
      }
      
      if ( $(this).find('.cat_10-dropdown__input-input') ) {
        $(this).find('.cat_10-dropdown__input-input').on('change', function(){
          if ( $(this).is(':checked') ) {
            $(toggle).text( $(this).siblings('.cat_10-dropdown__input__label').text() );
          }
        });
      }
    });
  }

  //accordion
  if ( $('.accordion-inner').length ) {
    $('.accordion-inner').each(function(){
      const toggle = $(this).find('.accordion-inner__title button');
      const title = $(this).find('.accordion-inner__title');
      const content = $(this).find('.accordion-inner__content');

      if ( ! content.hasClass('open-on-load') ) {
        content.hide();
      }

      toggle.on('click', function(){
        content.slideToggle();
        const expanded = $(this).attr('aria-expanded');
        $(this).attr('aria-expanded', expanded == 'true' ? 'false' : 'true');
        title.toggleClass('expanded');
      }).on('keypress', handleKeypressADA);
    });
  }
  
  if ( $('.logo-ticker').length ) {
    $('.logo-ticker').each(function() {
      const strip = $(this).find('.logo-ticker__strip');
      const thisRef = this;
      let oldSize = $(window).width();
      let stripW = strip.width();
      let curW = stripW;
      let clones = 0;
      let clonesArr = [];
      
      let speed = isMobile ? stripW / 24 : stripW / 50;
      
      while ( curW && curW !== 0 && curW < oldSize * 2 ) {
        curW += stripW;
        clones++;
        const clone = strip.clone(false);
        $(this).append(clone);
        
        gsap.set(clone, {
          x: ( clones * 100 ) + '%'
        });
        
        clonesArr.push(clone);
      }
      
      const loop = gsap.timeline({
        repeat: -1
      });
      
      loop.to(strip, {
        x: '-=100%',
        ease: 'linear',
        duration: () => {
          return speed;
        }
      });
      
      for ( let i = 0; i < clonesArr.length; i++ ) {
        loop.to(clonesArr[i], {
          x: '-=100%',
          ease: 'linear',
          duration: () => {
            return speed;
          }
        }, '0');
      }
      
      $(window).on('resize', function(){
        speed = isMobile ? stripW / 13 : stripW / 30
        if ( oldSize !== $(window).width() && oldSize < $(window).width() ) {
          const newW = $(window).width();
          if ( newW * 2 > curW ) {
            while ( curW && curW !== 0 && curW < newW * 2 ) {
              curW += stripW;
              clones++;
              const clone = strip.clone(false);
              $(thisRef).append(clone);
              
              gsap.set(clone, {
                x: ( clones * 100 ) + '%'
              });
              
              loop.to(clone, {
                x: '-=100%',
                ease: 'linear',
                duration: () => {
                  return speed;
                }
              }, '0');
              
              clonesArr.push(clone);
            }
            
            oldSize = newW;
          }
        }
      });
    });
  }
  
  if ( $('.bordered-grid').length ) {
    $('.bordered-grid').each(function(){
      if ( $(this).find('.bordered-grid-cell').length === 0 ) return;
      const thisRef = this;
      const badge = $(this).find('.bordered-grid__badge');
      const inner = $(this).children('.acf-innerblocks-container');
      const cellEx = $(this).find('.bordered-grid-cell').eq(0);
      const lastCell = $(this).find('.bordered-grid-cell').eq( $(this).find('.bordered-grid-cell').length - 1 );
      let badgeOffset = Math.ceil(cellEx.outerHeight() / 2) - 70;
      const offsetController = {
        y: 0
      }
      
      $(this).find('.bordered-grid-cell').each(function(){
        const thisRef = this;
        gsap.set(thisRef, {
          '--cell-width': $(thisRef).outerWidth() + 'px'
        });
        
        $(window).on('resize', function(){
          gsap.set(thisRef, {
            '--cell-width': $(thisRef).outerWidth() + 'px'
          });
        });
      });

      if ( ! badge.length ) return;
      
      ScrollTrigger.matchMedia({
        '(max-width: 767px)': function() {
          gsap.set(badge, {
            y: cellEx.outerHeight()
          });
        },
        '(min-width:768px)': function() {
          gsap.set(badge, {
            clearProps: 'y'
          });
          
          gsap.set(badge, {
            y: Math.ceil(cellEx.outerHeight() / 2) - 70
          });
          
          gsap.set(inner, {
            '--cell-height': cellEx.outerHeight() + 'px'
          });
          
          const offsetSetter = gsap.quickSetter(inner, '--map-offset', 'px');
          const badgePosSetter = gsap.quickSetter(badge, 'y', 'px');
          
          ScrollTrigger.create({
            trigger: cellEx,
            start: 'center center',
            endTrigger: lastCell,
            end: 'center center',
            // pin: badge,
            // pinSpacing: false,
            // pinType: 'fixed',
            onUpdate: ({progress, start, end}) => {
              const val = mapRange(progress, 0, 1, 0, end - start);
              gsap.to(offsetController, {
                y: val,
                overwrite: true,
                duration: 0.3,
                onUpdate: () => {
                  offsetSetter( offsetController.y );
                  badgePosSetter( offsetController.y + badgeOffset );
                }
              })
              
              
              
            }
          })
        }
      });
      
      $(window).on('resize', function(){
        gsap.set(badge, {
          clearProps: 'y'
        });
        
        if ( isMobile ) {
          gsap.set(badge, {
            y: cellEx.outerHeight()
          });
        } else {
          gsap.set(badge, {
            y: Math.ceil(cellEx.outerHeight() / 2) - 70
          });
        }
        
        gsap.set(inner, {
          '--cell-height': cellEx.outerHeight() + 'px'
        });
        
        badgeOffset = Math.ceil(cellEx.outerHeight() / 2) - 70;
      });
    });
  }
  
  if ( $('.animated-stamp-section').length ) {
    $('.animated-stamp-section').each(function(){
      const stamps = $(this).find('.animated-stamp-section__stamps img');
      const innerElements = $(this).find('.animated-stamp-section__inner').children();
      
      const thisRef = this;
      if ( stamps.length === 0 ) return;
      
      const loadingKisses = isMobile ? 3 : 5;
      const stampTimeline = gsap.timeline({
        scrollTrigger: {
          trigger: this,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      });
      
      for (let index = 0; index <= loadingKisses; index++) {
      
          let $kiss = document.createElement('span');
          $kiss.classList.add('animated-stamp-section__stamp');
          
          const randomSrc = stamps.eq(roundRandom(0, stamps.length - 1)).attr('src');
          $($kiss).css({
            'background-image': 'url(' + randomSrc + ')'
          });
          
          // $kiss.classList.add('-big');
          let width = roundRandom(50,100);
      
          $kiss.style.top = `${(random(0,$(thisRef).outerHeight() - $kiss.getBoundingClientRect().width))}px`;
          $kiss.style.left = `${random(0, $(thisRef).outerWidth() - $kiss.getBoundingClientRect().width)}px`;
          
          $(thisRef).append($kiss);
          
          gsap.set($kiss, {
            scale: 0.4
          });
          
          let needsNewPosition = false;
          const testPosition = () => {
            let needsNewPositionInner = false;
            $(innerElements).each(function(){
              const res = findContainment($kiss, this);
              if ( res !== 'outside' ) {
                needsNewPositionInner = true;
                return false;
              }
            });
            
            return needsNewPositionInner;
          };
          
          needsNewPosition = testPosition();
          
          while ( needsNewPosition ) {
            $kiss.style.top = `${(random(0,$(thisRef).outerHeight() - $kiss.getBoundingClientRect().width))}px`;
            $kiss.style.left = `${random(0, $(thisRef).outerWidth() - $kiss.getBoundingClientRect().width)}px`;
            
            needsNewPosition = testPosition();
          }
          
          gsap.set($kiss, {
            scale:0,
            alpha: 0,
            rotate: random(-45, 45) + 'deg'
          });
          
          let isAnimating = false;
          const randScale = random(0.5, 1);
          const runKiss = () => {
            if ( isAnimating === false ) {
              isAnimating = true;
              const tl = gsap.timeline();
              tl.fromTo($kiss,{
                scale: 0,
                alpha: 0
              },{
                scale: randScale,
                alpha: 1,
                duration: 0.4
              });
              
              tl.to($kiss,{
                scale: 0,
                alpha: 0,
                duration: 0.4,
                delay: 0.5,
                onComplete: function() {
                  isAnimating = false;
                }
              });
            }
          }
          
          stampTimeline.to({x: 0}, {
            x: 1,
            onStart: function(){
              runKiss();
            }
          });
      }
    });
  }
  
  if ( $('.animated-stamp-section__stamps.right-sprinkle').length ) {
    $('.animated-stamp-section__stamps.right-sprinkle').each(function(){
      const stamps = $(this).find('img');
      const parent = $(this).parent();
      parent.get(0).style.position = 'relative';
      if ( stamps.length === 0 ) return;
      
      const loadingKisses = Math.round(random(2,4));
      const stampTimeline = gsap.timeline({
        scrollTrigger: {
          trigger: parent,
          start: 'top bottom',
          end: '+=500',
          scrub: true
        }
      })
      
      for (let index = 0; index <= loadingKisses; index++) {
          let $kiss = document.createElement('span');
          $kiss.classList.add('animated-stamp-section__stamp');
          
          const randomSrc = stamps.eq(roundRandom(0, stamps.length - 1)).attr('src');
          $($kiss).css({
            'background-image': 'url(' + randomSrc + ')'
          });
          
          // $kiss.classList.add('-big');
          let width = roundRandom(50,100);
      

          $kiss.style.top = `${ isMobile ? ( (index - ( loadingKisses / 2 ) + 1 )  * 56 ) : ( (index - 0.3) * 72 ) }px`;
          $kiss.style.left = `${ ( $(parent).outerWidth() - ( index % 2 === 0 ? isMobile ? ( random(90,170) ) : (random(180,220)) : random(0,90) ) ) }px`;
          
          $(parent).append($kiss);
          console.log($kiss);
          
          gsap.set($kiss, {
            scale: 0.4
          });
          
          gsap.set($kiss, {
            scale:0,
            alpha: 0,
            rotate: random(-45, 45) + 'deg'
          });
          
          let isAnimating = false;
          const randScale = random(0.5, 1);
          const runKiss = () => {
            if ( isAnimating === false ) {
              isAnimating = true;
              const tl = gsap.timeline();
              tl.fromTo($kiss,{
                scale: 0,
                alpha: 0
              },{
                scale: randScale,
                alpha: 1,
                duration: 0.4
              });
              
              tl.to($kiss,{
                scale: 0,
                alpha: 0,
                duration: 0.4,
                delay: 0.5,
                onComplete: function() {
                  isAnimating = false;
                }
              });
            }
          }
          
          stampTimeline.to({x: 0}, {
            x: 1,
            onStart: function(){
              runKiss();
            }
          });
      }
    });
  }
  
  if ( $('.featured-content-block.has-title').length ) {
    $('.featured-content-block.has-title').each(function(){
      const title = $(this).find('.featured-content-block__upper-title');
      const thisRef = this;
      gsap.set(this, {
        '--mask-width': $(title).outerWidth() + 'px'
      });
      
      $(window).on('resize', function(){
        gsap.set(thisRef, {
          '--mask-width': $(title).outerWidth() + 'px'
        });
      });
    });
  }

  function isFutureDate(dateStr) {
    if ( ! dateStr || typeof dateStr !== 'string' ) {
      return false;
    }
    // Expected format: MM/DD/YYYY
    const parts = dateStr.split('/');
    if (parts.length !== 3) return false;

    const month = parseInt(parts[0], 10) - 1; // month is 0-indexed
    const day = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);

    // Create the provided date
    const providedDate = new Date(year, month, day);

    // Get today's date and reset time
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return providedDate > today;
  }

  if ( $('.cat-10-calendar').length ) {
    $('.cat-10-calendar').each(function(){
      const thisRef = this;
      const venues = $(this).data('venues');
      let ajaxIsLoading = false;
      const highlightUpcoming = String( $( this ).data( 'highlight-upcoming' ) ) === '1';
      let highlightDatesByCategories = [];
      if ( highlightUpcoming ) {
        const rawHighlightDatesByCategories = $( this ).data( 'highlightDatesByCategories' );
        if ( Array.isArray( rawHighlightDatesByCategories ) ) {
          highlightDatesByCategories = rawHighlightDatesByCategories;
        } else if ( typeof rawHighlightDatesByCategories === 'string' && rawHighlightDatesByCategories ) {
          try {
            const parsed = JSON.parse( rawHighlightDatesByCategories );
            highlightDatesByCategories = Array.isArray( parsed ) ? parsed : [];
          } catch ( e ) {
            highlightDatesByCategories = [];
          }
        }
      }
      
      const initDate = $(this).data('initdate');
      const minDate = $(this).data('mindate');
      const initDateObj = new Date( initDate.replace(/-/g, "/") );
      const dateInput = $(this).find('.cat-10-calendar__calendar__dateinput');
      const calendarHolder = $(this).find('.cat-10-calendar__date-dropdown--container');
      let activeFilter = 'all';
      let eventFilter = 'all';

      const parseUsDate = function ( str ) {
        const p = String( str || '' ).split( '/' );
        if ( p.length !== 3 ) {
          return null;
        }
        const d = new Date( parseInt( p[2], 10 ), parseInt( p[0], 10 ) - 1, parseInt( p[1], 10 ) );
        return isNaN( d.getTime() ) ? null : d;
      };

      const parseUsDateStrings = function ( arr ) {
        if ( ! Array.isArray( arr ) ) {
          return [];
        }
        return arr.map( function ( s ) {
          return parseUsDate( s );
        } ).filter( function ( d ) {
          return d && ! isNaN( d.getTime() );
        } );
      };

      const applyUpcomingHighlight = function ( datesInput ) {
        if ( ! highlightUpcoming ) {
          return;
        }
        const dp = dateInput.data( 'ab.datepicker' );
        if ( ! dp ) {
          return;
        }
        let dates = [];
        if ( Array.isArray( datesInput ) ) {
          dates = parseUsDateStrings( datesInput );
        } else if ( datesInput ) {
          const one = parseUsDate( datesInput );
          if ( one ) {
            dates = [ one ];
          }
        }
        dp.options.highlightDates = dates.length ? dates : null;
        dp.refresh();
      };

      let initialHighlightDates = [];
      if ( highlightUpcoming ) {
        const rawUpcoming = $( this ).data( 'upcomingDates' );
        if ( Array.isArray( rawUpcoming ) ) {
          initialHighlightDates = parseUsDateStrings( rawUpcoming );
        } else if ( typeof rawUpcoming === 'string' && rawUpcoming ) {
          try {
            const parsed = JSON.parse( rawUpcoming );
            initialHighlightDates = parseUsDateStrings( parsed );
          } catch ( e ) {
            initialHighlightDates = [];
          }
        }
      }
      
      dateInput.datepicker({
        inline: calendarHolder,
        outputFormat: 'MM/dd/y',
        isDateDisabled: function (date) { 
          const yday = new Date( initDate.replace(/-/g, "/") );
          yday.setDate( yday.getDate() - 1 );
          return date < yday;
        },
        min: minDate,
        highlightDates: initialHighlightDates.length ? initialHighlightDates : null
      });
      
      dateInput.datepicker('setDate', initDateObj);
      
      const prevButton = $(this).find('.cat-10-calendar__main-nav-button.prev');
      const nextButton = $(this).find('.cat-10-calendar__main-nav-button.next');
      const curDateTitle = $(this).find('.cat-10-calendar__main-nav__curdate');
      const eventsList = $(this).find('.cat-10-calendar__main-events');
      const description = $(this).find('.cat-10-calendar__description');
      
      const filterInputs = $(this).find('.archive-block__filter-input input[name="location"]');
      const eventFilterInputs = $(this).find('.archive-block__filter-input input[name="events"]');
      const filterToggle = $(this).find('.archive-block__filter-toggle');
      
      const now = new Date();
      
      let categoryFilter = 'all';
      
      const modifyDisplayedContainerJumpLinks = () => {
        if ( $('.calendar-buckets__dropdown__list-item a').length ) {
          let foundAnyBuckets = false;
          $('.calendar-buckets__dropdown__list-item a').each(function(){
            if ( $($(this).attr('href')).length ) {
              foundAnyBuckets = true;
              $(this).parent().show();
            } else {
              $(this).parent().hide();
            }
          });
          
          if ( foundAnyBuckets === false ) {
            $('#calendar-buckets__container').hide();
          } else {
            $('#calendar-buckets__container').show();
          }
        }
      };
      
      const modifyDisplayedCategories = () => {
        if ( $('.calendar-categories__input-input').length ) {
          let foundAnyCategories = false;
          $('.calendar-categories__input-input').each(function(){
            const key = $(this).attr('value');
            if ( $.makeArray($(thisRef).find('.content-card')).some(function(el){
              console.log($(el).data('event-category'));
              return $(el).data('event-category').includes(key);
            }) ) {
              foundAnyCategories = true;
              $(this).closest('li').show();
            } else if ( key !== 'all' ) {
              $(this).closest('li').hide();
            }
            
          });
          
          if ( foundAnyCategories === false ) {
            $('#calendar-categories__container').hide();
            categoryFilter = 'all';
            
          } else {
            $('#calendar-categories__container').show();
          }
        }
      };
      
      const applyCategoryFilter = () => {
        $(thisRef).find('.content-card').each(function(){
          if ( $(this).data('event-category').includes(categoryFilter) || categoryFilter === 'all' ) {
            $(this).closest('li').show();
          } else {
            $(this).closest('li').hide();
          }
        });
        
        if ( $(thisRef).find('.events-today__events-group').length ) {
          $(thisRef).find('.events-today__events-group').each(function(){
            $(this).show();
            if ( $.makeArray( $(this).find('.content-card')).some( function(el){
              return $(el).is(':visible');
            } ) ) {
              $(this).hide();
              $(this).fadeIn();
            } else {
              $(this).hide();
            }
          });
        }
        
        let target = $( thisRef ).offset().top - 148;
        let dist = Math.abs($(window).scrollTop() - target);
        
        $([document.documentElement, document.body]).animate({
          scrollTop: target
        }, Math.min(1200, ((dist / 1200) * 1000)));
      };
      
      $('.calendar-categories__input-input').on('change', function(){
        getDatePage( $('.cat-10-calendar__main-nav__curdate').data('date'), '', '' );
        if ( $(this).is(':checked') ) {
          categoryFilter = $(this).attr('value');
          // applyCategoryFilter();
        }
      });
      
      modifyDisplayedContainerJumpLinks();
      // modifyDisplayedCategories();
      
      const getDatePage = (date, navigation, category) => {
        ajaxIsLoading = true;
        $(eventsList).addClass('loading');
        if ( '' == category ) {
          category = $('.calendar-categories__input-input:checked').val();
        }
        var emptyMessage = $('.cat-10-calendar__main-nav__curdate').data('empty-message');
        
        const args = {
          date: date,
          venues: venues,
          category: category,
          navigation: navigation,
          emptyMessage: emptyMessage,
          highlightUpcoming: highlightUpcoming ? 1 : 0,
          highlightDatesByCategories: highlightDatesByCategories
        };
        
        $.post(cat_10Vars.ajaxURL, {
          action: 'cat_10_get_calendar',
          args: args,
          timestamp: now.toString()
        }, function(data) {
          try {
            const res = JSON.parse(data);
            console.log(res);
            
            if ( res.status === 'OK' ) {
              $(eventsList).html( res.page );
              
              $(curDateTitle).text( res.date_time );
              $(curDateTitle).attr( 'data-date', res.date );
              const synced = String( res.date ).split( '/' );
              if ( synced.length === 3 ) {
                const syncedDate = new Date(
                  parseInt( synced[2], 10 ),
                  parseInt( synced[0], 10 ) - 1,
                  parseInt( synced[1], 10 )
                );
                dateInput.datepicker( 'setDate', syncedDate );
              }
              if ( highlightUpcoming ) {
                applyUpcomingHighlight( Array.isArray( res.upcoming_highlight_dates ) ? res.upcoming_highlight_dates : [] );
              }
              $(nextButton).data('date', res.next_day );
              $(description).toggleClass('is-hide-description', res.hide_description);
              
              if ( res.prev_day !== false ) {
                $(prevButton).get(0).removeAttribute('disabled');
                $(prevButton).data('date', res.prev_day);
              } else {
                $(prevButton).attr('disabled', '');
              }
              
              modifyDisplayedContainerJumpLinks();
              // modifyDisplayedCategories();
              // applyCategoryFilter();
            }
          } catch (err) {
            console.log( err );
          }
        }).always(function(){
          ajaxIsLoading = false;
          $(eventsList).removeClass('loading');
        });
      };
      
      $(this).find('.cat-10-calendar__main-nav-button').on('click', function(){
        if ( ajaxIsLoading === false ) {
          var category = $('.cat-10-calendar__main-nav__curdate').data('category');
          if ( $( this ).hasClass( 'prev' ) ) {
            getDatePage( $(this).data('date'), 'prev', category );
          } else {
            getDatePage( $(this).data('date'), 'next', category );
          }
        }
      });
      
      $(dateInput).on('change', function(){
        if ( ajaxIsLoading === false ) {
          var category = $('.cat-10-calendar__main-nav__curdate').data('category');
          getDatePage( this.value, 'calendar', category );
        }
      });

      // Trigger on page load.
      if ( cat_10Vars.date ) {
        let dateParam = String( cat_10Vars.date ).replace(/-/g, "/");
        if ( isFutureDate( dateParam ) ) {
          $('.cat-10-calendar__main-nav__curdate').attr( 'data-date', dateParam );
          getDatePage( dateParam, 'calendar', '' );
        }
      }
      
    });
  }
  
  if ( $('.parallax-hero').length ) {
    $('.parallax-hero').each(function(){
      const text = $(this).children('.acf-innerblocks-container').children();
      let split = false;
      const bg = $(this).find('.parallax-hero__image');
      if ( bg.length ) {
        gsap.set(bg, {
          y: '-100%'
        });
        
        ScrollTrigger.create({
          trigger: this,
          start: 'top bottom',
          end: 'bottom top',
          pin: bg,
          pinType: 'fixed'
        });
      }
      
      const initAnim = () => {
        split = new SplitText(text, {
          type: 'lines'
        });
        
        gsap.set(split.lines, {
          opacity: 0.4
        });
        
        for ( let i = 0; i < split.lines.length; i++ ) {
          ScrollTrigger.create({
            trigger: split.lines[i],
            start: 'top bottom-=80',
            end: 'bottom top',
            onEnter: () => {
              gsap.to(split.lines[i], {
                opacity: 1,
                duration: 0.6,
                overwrite: true,
                ease: 'power3.inOut'
              });
            }
          });
          
          ScrollTrigger.create({
            trigger: split.lines[i],
            start: 'top bottom',
            end: 'bottom top',
            onLeaveBack: () => {
              gsap.set(split.lines[i], {
                opacity: 0.4
              });
            }
          });
        }
      }
      
      initAnim();
      
      $(window).on('resize', function(){
        split.revert();
        initAnim();
      });
    });
  }
  
  if ( $('.hat-wall').length ) {
    $('.hat-wall').each(async function(){
      const thisRef = this;
      const list = $(this).find('.hat-wall__list');
      const dragContainer = this.querySelector('.hat-wall__list');
      const wallContainer = this.querySelector('.hat-wall__wall-view');
      const hats = this.querySelectorAll('.hat-wall__list-item.hat');
      const hatImgs = this.querySelectorAll('.hat-wall__list-item.hat button');
      
      const filterGroupToggle = this.querySelector('.hat-wall__controls-filters__toggle');
      const filterGroup = this.querySelector('.hat-wall__controls-filters-inner');
      let filtersOpen = false;

      const status = this.querySelector('.hat-wall__instructions-modal__inner h2');

      // this.querySelector('.hat-wall__instructions-modal__inner h2').textContent = 'Loading';
      $(this).find('.hat-wall__instructions-modal p:last-of-type').hide();
      $(this).find('.hat-wall__instructions-modal .wp-block-button').hide();
      $(this).find('.hat-wall__instructions-modal__dismiss').hide();
      const imgsToLoad = this.querySelectorAll('.hat-wall__list-item.hat img');
      const loaderBar = this.querySelector('.hat-wall__instructions-modal__loader-bar span');
      const curNum = this.querySelector('.hat-wall__instructions-modal__loader-text .cur');
      const totNum = this.querySelector('.hat-wall__instructions-modal__loader-text .tot');
      let imgsToLoadNum = imgsToLoad.length;
      totNum.textContent = imgsToLoadNum;
      let imgsLoaded = 0;

      const start = new Date();

      for ( const img of imgsToLoad ) {
        const req = new Request(img.src, {
          method: 'GET',
          mode: 'cors'
        });

        try {
          await addImageProcess(img.src);
        } catch(err) {
          console.log(err);
        } finally {
          imgsLoaded++;
          // status.textContent = 'Loading ' + imgsLoaded + ' of ' + imgsToLoadNum;
          gsap.to(loaderBar, {
            scaleX: imgsLoaded / imgsToLoadNum,
            duration: 0.1,
            overwrite: true,
            ease: 'linear'
          });

          curNum.textContent = imgsLoaded;
        }
      }

      const end = new Date();
      if ( end - start < 2000 ) {
        await asyncTimeout(600);
      }

      $(this).removeClass('loading');
      $(this).find('.hat-wall__instructions-modal .wp-block-button').slideDown();
      $(this).find('.hat-wall__instructions-modal p:last-of-type').slideDown();
      $(this).find('.hat-wall__instructions-modal__dismiss').fadeIn();
      $(this).find('.hat-wall__instructions-modal__loader').slideUp();

      let availableFilteredStates = availableStates;
      
      $(filterGroupToggle).on('click', function(){
        filtersOpen = !filtersOpen;
        $(this).toggleClass('expanded');
        if ( filtersOpen ) {
          gsap.to(filterGroup, {
            y: '-100%',
            overwrite: true,
            ease: 'power3.inOut'
          });
        } else {
          gsap.to(filterGroup, {
            y: '0%',
            overwrite: true,
            ease: 'power3.inOut'
          });
        }
      });
      
      const filters = {
        name: [],
        location: [],
        color: [],
        luke: false
      };
      
      const dragObj = Draggable.create(dragContainer, {
        type: 'x,y',
        inertia: true,
        bounds: this
      })[0];
      
      let anyFiltersActive = false;
      
      const possibleCoordinates = [];
      
      const centerPosition = {
        x: 8,
        y: 10
      };
      
      
      for ( let x = 1; x <= 15; x++ ) { 
        for ( let y = 1; y <= 19; y++ ) {
          if ( x === centerPosition.x && y === centerPosition.y ) continue;
          
          possibleCoordinates.push({
            x: x,
            y: y
          });
        }
      }
      
      possibleCoordinates.sort(function(a,b){
        const xdiffa = centerPosition.x - a.x;
        const ydiffa = centerPosition.y - a.y;
        const dista = Math.sqrt( (xdiffa * xdiffa ) + ( ydiffa * ydiffa ) );
        
        const xdiffb = centerPosition.x - b.x;
        const ydiffb = centerPosition.y - b.y;
        const distb = Math.sqrt( (xdiffb * xdiffb ) + ( ydiffb * ydiffb ) );
        
        return dista - distb;
      });
      
      const hatCountSpan = $(this).find('.hat-wall__hat-count-num');
      
      const resetFilters = () => {
        $(this).find('input[type="text"]').val('');
        $(this).find('.hat-wall__checkbox-input').prop('checked', false);
        $(this).find('.hat-wall__color-input').prop('checked', false);
        $(this).find('.hat-wall__color-input').removeAttr('disabled');
        availableFilteredStates = availableStates;
        filters.name = [];
        filters.color = [];
        filters.location = [];
        filters.luke = false;
        
      };
      
      const applyFilters = async () => {
        
        let anyFiltersApplied = false;
        
        if ( filters.location.length > 0 ) {
          anyFiltersApplied = true;
          $(this).find('.hat-wall__color-input').each(function(){
            const thisColor = $(this).attr('value');
            const filterIsActive = $(hatImgs).toArray().some(function(el){
              return filters.location.includes($(el).data('location')) && $(el).data('color').includes( thisColor );
            });

            if ( !filterIsActive ) {
              $(this).prop('disabled', true);
            } else {
              $(this).removeAttr('disabled');
            }
          });
        }
        
        if ( filters.color.length > 0 ) {
          anyFiltersApplied = true;
          availableFilteredStates = availableStates.filter( (state) => {
            return $(hatImgs).toArray().some(function(el){
              return $(el).data('location') === state && $(el).data('color').filter( (color) => { return filters.color.includes( color ) }).length > 0;
            });
          });

          console.log(availableFilteredStates);
        }
        
        if ( filters.luke === true ) {
          anyFiltersApplied = true;
        }
        
        if ( anyFiltersApplied ) {
          anyFiltersActive = true;
          
          const dragState = Flip.getState(dragContainer);
          
          gsap.set(dragContainer, {
            clearProps: 'x,y'
          });
          
          Flip.from(dragState, {
            ease: 'power3.inOut',
            onComplete: function() {
              dragObj.update();
              // dragObj.applyBounds({minX: 10, maxX: 300, minY: 50, maxY: 500});
            }
          });
          
          const savedState = Flip.getState(hats);
          let shownIndex = 0;
          
          $(hatImgs).each(function(){
            let needsHide = false;
            
            if ( filters.location.length > 0 ) {
              if ( '' == $(this).data('location') || !filters.location.includes( $(this).data('location') ) ) {
                needsHide = true;
              }
            }
            
            if ( filters.color.length > 0 ) {
              if ( $(this).data('color').length === 0 || $(this).data('color').filter( (color) => { return filters.color.includes( color ); } ).length === 0 ) {
                needsHide = true;
              }
             }
             
             if ( filters.luke === true && $(this).data('luke') === false ) {
               needsHide = true;
             }
            
            if ( needsHide ) {
              $(this).closest('li').hide();
              $(this).closest('li').css({
                'grid-column': '',
                'grid-row': ''
              });
            } else {
              $(this).closest('li').show();
              const pos = possibleCoordinates[shownIndex];
              
              $(this).closest('li').css({
                'grid-column': pos.x + ' / span 1',
                'grid-row': pos.y + ' / span 1'
              })
              shownIndex++;
            }
          });
          
          hatCountSpan.text( shownIndex );
          
          Flip.from(savedState, {
            absolute: true,
            duration: 1.5,
            onEnter: elements => gsap.fromTo(elements, {scale: 0}, {scale: 1}),
            onLeave: elements => gsap.fromTo(elements, {scale: 1, onStart: function(){
              console.log(this);
            }}, {scale: 0}),
            simple: true,
            ease: 'power3.inOut',
            stagger: {
              amount: 0.8,
              from: 'center'
            }
          });
        } else {
          hatCountSpan.text( $(hats).length );
          dragObj.applyBounds(thisRef);
          if ( anyFiltersActive === true ) {
            const savedState = Flip.getState(hats);
            $(hats).show();
            $(hats).css({
              'grid-column': '',
              'grid-row': ''
            });
            
            Flip.from(savedState, {
              absolute: true,
              duration: 1.5,
              onEnter: elements => gsap.fromTo(elements, {scale: 0}, {scale: 1}),
              onLeave: elements => gsap.fromTo(elements, {scale: 1, onStart: function(){
                console.log(this);
              }}, {scale: 0}),
              simple: true,
              ease: 'power3.inOut',
              stagger: {
                amount: 0.8,
                from: 'center'
              }
            })
          }
        }
      };
      
      function split( val ) {
        return val.split( /,\s*/ );
      }
      
      function extractLast( term ) {
        return split( term ).pop();
      }
      
      $(this).find('.hat-wall__apply-filters').on('click', function(){
        if ( mode === 'wall' ) {
          toggleLayout( function() {
            layoutToggleButton.removeClass('active');
            applyFilters();
          } );
        } else {
          applyFilters();
        }
      });
      
      $(this).find('.hat-wall__reset-filters').on('click', function(){
        resetFilters();
        applyFilters();
      });
      
      const stateTerms = [];
      
      const stateInput = $(this).find('.hat-wall__controls-filters__search-input.state');
      stateInput.autocomplete({
        source: availableStates,
        minLength: 0,
        source: function( request, response ) {
          // delegate back to autocomplete, but extract the last term
          response( $.ui.autocomplete.filter(
            availableFilteredStates, extractLast( request.term ) ) );
        },
        select: function( event, ui ) {
          // add the selected item
          stateTerms.push( ui.item.value );
          // add placeholder to get the comma-and-space at the end
          stateTerms.push( "" );
          this.value = stateTerms.join( ", " );
          console.log(stateTerms);
          $(stateInput).trigger('change');
          return false;
        },
        focus: function() {
          // prevent value inserted on focus
          return false;
        },
      });
      
      $(stateInput).on('change', function(){
        
        if ( this.value != '' ) {
          filters.location = stateTerms;
        } else {
          filters.location = [];
          stateTerms.splice(0, stateTerms.length);
        }

        if ( mode === 'wall' ) {
          toggleLayout( function() {
            layoutToggleButton.removeClass('active');
            applyFilters();
          } );
        } else {
          applyFilters();
        }
      });
      
      $(this).find('.hat-wall__controls-filters__search-input').on('change', function(){
        if ( '' != this.value ) {
          $(this).next('.hat-wall__controls-filters__search-clear').show();
        } else {
          $(this).next('.hat-wall__controls-filters__search-clear').hide();
        }
      });
      
      $(this).find('.hat-wall__controls-filters__search-clear').on('click', function(){
        $(this).prev('.hat-wall__controls-filters__search-input').val('').trigger('change'); 
        $(thisRef).find('.hat-wall__color-input').removeAttr('disabled');
      });
      
      $(stateInput).on('focus', function(){
        $(this).autocomplete('search', '');
      });
      
      $(this).find('.hat-wall__color-input').on('change', function(){
        if ( $(this).is(':checked') ) {
          filters.color.push( $(this).attr('value') );
        } else {
          const index = filters.color.indexOf( $(this).attr('value') );
          if (index !== -1) {
            filters.color.splice(index, 1);
          }
        }
        
        if ( mode === 'wall' ) {
          toggleLayout( function() {
            layoutToggleButton.removeClass('active');
            applyFilters();
          } );
        } else {
          applyFilters();
        }
      });
      
      $(this).find('.hat-wall__checkbox-input').on('change', function(){
        filters.luke = $(this).is(':checked');
        
        if ( mode === 'wall' ) {
          toggleLayout( function() {
            layoutToggleButton.removeClass('active');
            applyFilters();
          } );
        } else {
          applyFilters();
        }
      });
      
      
      const nameInput = $(this).find('.hat-wall__controls-filters__search-input.name');
      $(nameInput).autocomplete({
        source: availableNames,
        select: function( event, ui ) {
          $( nameInput ).val( ui.item.label );
          
          const butt = $('.hat-wall__hat-trigger[data-postid="' + ui.item.hat_id + '"]');
          if ( butt.length ) {
            $(butt).click();
          }
        
          return false;
        }
      }).autocomplete( "instance" )._renderItem = function( ul, item ) {
        return $( "<li>" )
          .append( "<div>" + item.label + "<br>" + item.location + "</div>" )
          .appendTo( ul );
      };
      
      const coordInput = $(this).find('.hat-wall__controls-filters__search-input.location');
      $(coordInput).autocomplete({
        source: availableCoordinates,
        minLength: 0,
        select: function( event, ui ) {
          $( coordInput ).val( ui.item.label );
          
          const butt = $('.hat-wall__hat-trigger[data-postid="' + ui.item.hat_id + '"]');
          if ( butt.length ) {
            $(butt).click();
          }
        
          return false;
        }
      });
      
      $(coordInput).on('focus', function(){
        $(this).autocomplete('search', '');
      });
      
      let mode = 'hat';
      let savedState = null;
      
      const hatViewLogo = $(list).find('.logo-container img');
      const wallViewLogo = $(wallContainer).find('.hat-wall__wall-view__tv img');
      
      gsap.set(wallViewLogo, {
        y: '100%',
        opacity: 0
      });
      
      const toggleLayout = (callback = false) => {
        if ( mode === 'hat' ) {
          mode = 'wall';
          $(thisRef).addClass('wall');
          $(thisRef).removeClass('hat');
          
          dragObj.disable();
          $(dragContainer).css('pointer-events', 'none');
          
          $(list).addClass('wall-view');
          
          // const savedState = Flip.getState( hats, {
          //   simple: true
          // } );

          gsap.to(hatViewLogo, {
            scale: 0,
            duration: 0.6,
            ease: 'power3.inOut'
          })

          gsap.to( hats, {
            opacity: 0,
            duration: 0.6,
            onComplete: function() {
              $(hats).show();
              $(hats).css({
                'grid-column': '',
                'grid-row': ''
              });
              
              $(wallContainer).show();
              
              $(hats).each(function(){
                $(wallContainer).append( this );
                const but = $(this).find('button');
                const pos = {
                  column: parseInt(but.data('column')),
                  row: but.data('row').charCodeAt(0) - 64
                };
                
                
                
                if ( pos.row >= 14 && pos.column > 4 ) {
                  pos.column = pos.column + 10;
                  console.log('spanning');
                } 
                
                $(this).css({
                  'grid-column': (pos.column) + ' / span 1',
                  'grid-row': (pos.row) + ' / span 1'
                });
              });

              gsap.to(hats, {
                opacity: 1,
                duration: 0.6
              });

              gsap.to(wallViewLogo, {
                y: '0%',
                opacity: 1,
                duration: 0.6,
                ease: 'power3.inOut'
              });
                    
              if ( typeof callback === 'function' ) {
                callback();
              }
            }
          } );
          
        } else {
          mode = 'hat';
          $(thisRef).addClass('hat');
          $(thisRef).removeClass('wall');
          
          dragObj.enable();
          $(dragContainer).css('pointer-events', 'auto');
          
          // const savedState = Flip.getState( hats, {
          //   simple: true
          // } );

          gsap.to(wallViewLogo, {
            y: '100%',
            opacity: 0,
            duration: 0.6,
            ease: 'power3.inOut'
          });

          gsap.to(hats, {
            opacity: 0,
            duration: 0.6,
            onComplete: function() {
              gsap.set(hats, {
                clearProps: 'grid-column,grid-row'
              });
              
              $(hats).each(function(){
                $(list).append( this );
              });

              gsap.to(hats, {
                opacity: 1,
                duration: 0.6,
                onComplete: function() {
                  gsap.to(hatViewLogo, {
                    scale: 1,
                    duration: 0.6,
                    ease: 'power3.inOut'
                  })
                  
                  if ( typeof callback === 'function' ) {
                    callback();
                  }
                }
              })
            } // end oncomplete
          })

          
        }
      };
      
      const layoutToggleButton = $(this).find('.hat-wall__layout-toggle');
      
      layoutToggleButton.on('click', function(){
        $(this).toggleClass('active');
        toggleLayout();
      });
      
      const instructions = this.querySelector('.hat-wall__instructions-modal');
      if ( instructions !== null ) {
        let instructionsAreOpen = true;
        const instructionsInner = this.querySelector('.hat-wall__instructions-modal__inner');
        const closeInstructions = (callback = false) => {
          gsap.to(instructions, {
            opacity: 0,
            onComplete: function() {
              $(instructions).css({
                visibility: 'hidden',
                'pointer-events': 'none'
              });
              instructionsAreOpen = false;
              
              if (  typeof callback === 'function' ) {
                callback();
              }
            }
          })
        }
        
        const inDismiss = instructions.querySelector('.hat-wall__instructions-modal__dismiss');
        $(inDismiss).on('click', function() {
          closeInstructions();
        });
        
        const inFind = instructions.querySelector('.hat-wall__instructions-modal__find');
        $(inFind).on('click', function(){
          closeInstructions(()=>{
            $(thisRef).find('.hat-wall__controls-filters__toggle').click();
          });
        });
        
        $(thisRef).find('.hat-wall__instructions-trigger').on('click', function(){
          gsap.fromTo(instructions, {
            opacity: 0,
          }, {
            opacity: 1,
            duration: 0.6,
            onStart: function(){
              $(instructions).css({
                visibility: 'visible',
                'pointer-events': 'auto'
              });
              
              gsap.fromTo(instructionsInner, {
                y: 36,
                scale: 0.95,
                opacity: 0
              }, {
                y: 0,
                scale: 1,
                opacity: 1,
                duration: 0.6
              })
            },
            onComplete: function() {
              instructionsAreOpen = true;
            }
          });
        });
        
        $(window).on('click', function(e) {
          if ( instructionsAreOpen && (e.target !== instructionsInner && !instructionsInner.contains(e.target)) ) {
            closeInstructions();
          }
        });
      }
      
      const modal = this.querySelector('.hat-wall__modal');
      const modalInner = modal.querySelector('.hat-wall__modal-inner');
      let hatModalIsOpen = false;
      
      $(modal).find('.hat-wall__modal-wall--toggle').on('click', function(){
        if ( isMobile ) {
          $(this).toggleClass('expanded');
          $(this).next().slideToggle();
        }
      });
      
      const modalDismiss = modal.querySelector('.hat-wall__modal-close');
      const closeModal = () => {
        gsap.to(modal, {
          opacity: 0,
          onComplete: function() {
            $(modal).css({
              visibility: 'hidden',
              'pointer-events': 'none'
            });
            hatModalIsOpen = false;
            
            $(modal).find('.hat-wall__modal-image *').remove();
            $(modal).find(".hat-wall__modal-content *").remove();
            $(modal).find('.hat-point').removeClass('in-focus');
          }
        })
      };
      
      $(modalDismiss).on('click', function(){
        closeModal();
      });
      
      $(window).on('click', function(e) {
        if ( hatModalIsOpen && (e.target !== modalInner && !modalInner.contains(e.target)) ) {
          closeModal();
        }
      });
      
      $(this).find('.hat-wall__hat-trigger').on('click', function(){
        if ( this.querySelector('img').hasAttribute('data-fullsize') ) {
          this.querySelector('img').src = this.querySelector('img').getAttribute('data-fullsize');
        }
        const clone = $(this).find('img').clone();
        $(this).append(clone);
        
        gsap.set(modalInner, {
          y: 4,
          opacity: 0,
          scale: 0.98
        })
        
        const savedStateClone = Flip.getState([clone.get(0), modalInner], {
          simple: true
        });
        
        $(modal).find('.hat-wall__modal-image').append(clone);
        $(modal).find('.hat-wall__modal-title-name').text( $(this).data('name') );
        $(modal).find('.hat-wall__modal-fname').text( $(this).data('firstname') );
        $(modal).find('.hat-wall__modal-coord').text( $(this).data('row') + $(this).data('column') )
        $(modal).find('.hat-point[data-coord="' + ( $(this).data('row') + $(this).data('column') ) + '"]').addClass('in-focus');
        
        if ( $(this).data('location-name') ) {
          $(modal).find('.hat-wall__modal-location').show();
          $(modal).find('.hat-wall__modal-location-name').text( $(this).data('location-name') );
        } else {
          $(modal).find('.hat-wall__modal-location').hide();
        }
        
        gsap.set(modalInner, {
          y: 0,
          opacity: 1,
          scale: 1
        });
        
        
        if ( $(this).data('has-content') ) {
          // add some ghosts
          
          $.post(cat_10Vars.ajaxURL, {
            action: 'cat_10_get_hat_content',
            args: {
              'post_id': $(this).data('postid')
            }
          }, function(data) {
            console.log(data);
            try {
              const res = JSON.parse(data);
              console.log(res);
              if ( res.status === 'success' ) {
                $(modal).find('.hat-wall__modal-content').html( res.content );
              }
            } catch (err) {
              console.log( err );
            }
          });
        }
        
        
        gsap.to(modal, {
          opacity: 1,
          onStart: function() {
            $(modal).css({
              visibility: 'visible',
              'pointer-events': 'auto'
            });
            
            Flip.from(savedStateClone, {
              absolute: true,
              duration: 0.6,
              nested: true,
              ease: 'power3.inOut',
            });
          },
          onComplete: function() {
            hatModalIsOpen = true;
          }
        })
      });
    });
  }
  /* END GUTENBERG SCRIPTS */

  /* ARCHIVE BLOCK SCRIPTS */
  if ( $('.archive-block').length ) {
    $('.archive-block').each(function(){
      const archiveBlock = $(this);
      const archiveFeed = $(this).find('.archive-block__feed');
      const archivePagination = $(this).find('.archive-block__pagination-container');

      const archiveFilterForm = $(this).find('.archive-block__header');
      const archiveSortInputs = $(this).find('.archive-block__sort__input-input');
      const archiveSearchInput = $(this).find('.archive-block__search-input');
      const archiveSearchConfirm = $(this).find('.archive-block__search-confirm');

      const archiveFilterGroups = $(this).find('.archive-block__filter');


      const base = $(this).data('baseurl');
      let currentURL = $(this).data('currenturl');
      const initPage = $(this).data('page');
      const postType = $(this).data('posttype');
      const exclude = $(this).data('exclude');

      let updateArchive;
      let stateObj = {
        base: base,
        url: currentURL,
        page: initPage,
        sort: 'default',
        postType: postType,
        search: false,
        mode: false,
        exclude: exclude,
        taxonomy: false,
        term: false,
        filters: {}
      };

      if ( this.hasAttribute('data-postsper') ) {
        stateObj.postsPerPage = $(this).data('postsper');
      }

      if ( this.hasAttribute('data-cardargs') ) {
        stateObj.cardArgs = $(this).data('cardargs');
      }
      
      if ( this.hasAttribute('data-taxonomy') ) {
        stateObj.taxonomy = $(this).data('taxonomy');
      }
      
      if ( this.hasAttribute('data-term') ) {
        stateObj.term = $(this).data('term');
      }
      
      if ( this.hasAttribute('data-mode') ) {
        stateObj.mode = $(this).data('mode');
      }
      
      if ( this.hasAttribute('data-searchterm') ) {
        stateObj.search = $(this).data('searchterm');
      }

      const updateURLFromFilters = () => {
        const baseurl = base[0] === '/' ? window.location.protocol + base : base;
        const url = new URL(baseurl);
        if ( stateObj.sort !== 'default' ) {
          url.searchParams.append('sort', stateObj.sort);
        }

        if ( stateObj.mode === 'search' && stateObj.search !== false ) {
          url.searchParams.append('s', stateObj.search);
        }

        if ( Object.keys(stateObj.filters).length ) {
          for ( const filterType in stateObj.filters ) {
            if ( Array.isArray(stateObj.filters[filterType]) ) {
              url.searchParams.append(filterType, stateObj.filters[filterType].join(','));
            } else {
              url.searchParams.append(filterType, stateObj.filters[filterType]);
            }
          }
        }

        stateObj.url = url.toString();
        stateObj.page = 1;

        updateArchive();
      };

      if ( archiveFilterGroups.length ) {
        $(archiveFilterGroups).each(function() {
          const inputs = $(this).find('input');

          $(inputs).each(function(){
            const name = $(this).attr('name');
            const type = $(this).attr('type');
            const val = $(this).attr('value');

            if ( $(this).is(':checked') ) {
              if ( type === 'radio' ) {
                stateObj.filters[ name ] = val;
              } else {
                if ( stateObj.filters.hasOwnProperty(name) ) {
                  stateObj.filters[ name ].push( val );
                } else {
                  stateObj.filters[ name ] = [ val ];
                }
              }
            }

            $(this).on('change', function(){
              if ( $(this).is(':checked') ) {
                if ( type === 'radio' ) {
                  stateObj.filters[ name ] = val;
                } else {
                  stateObj.filters[ name ].push( val );
                }
              } else if ( type === 'checkbox' ) {
                stateObj.filters[ name ] = stateObj.filters[name].filter( e => e !== val );
              }
              
              updateURLFromFilters();
            });
          });
        });
      }

      if ( archiveSortInputs.length ) {
        $(archiveSortInputs).each(function(){
          const val = $(this).attr('value');
          
          if ( $(this).is(':checked') ) {
            stateObj.sort = val;
          }
          
          $(this).on('change', function(){
            if ( $(this).is(':checked') ) {
              stateObj.sort = val;
              updateURLFromFilters();
            }
          });
        });
      }

      if ( archiveSearchInput.length ) {
        if ( archiveSearchInput.val() !== '' ) {
          stateObj.search = archiveSearchInput.val();
        }
      }

      if ( archiveSearchConfirm.length ) {
        archiveSearchConfirm.on('click', function(){
          const searchQuery = archiveSearchInput.val();
          if ( searchQuery !== '' ) {
            if ( stateObj.search !== searchQuery ) {
              stateObj.search = searchQuery;
            }

            updateURLFromFilters();
          } else {
            if ( stateObj.search !== false ) {
              stateObj.search = false;
              updateURLFromFilters();
            }
          }
        }).on('keypress', handleKeypressADA);
      }

      if ( archiveFilterForm.length ) {
        archiveFilterForm.on('submit', function(e){
          e.preventDefault();
          if ( archiveSearchConfirm.length ) {
            archiveSearchConfirm.trigger('click');
          }
        });
      }

      $(archivePagination).find('.pagination-container__pager').on('change', function(){
        stateObj.page = this.value;
        updateArchive();
      });

      $(archivePagination).on('click', 'a', function(e){
        e.preventDefault();
        if ( ajaxIsLoading === false ) {
          const url = $(e.target).attr('href');
          let page = 1;
          const urlparts = url.split('?')[0].split('/');
          let parsedNum = false;
          for ( let i = urlparts.length - 1; i >= 0; i-- ) {
            if ( urlparts[ i ] != '' ) {
              const parsed = parseInt( urlparts[ i ] );
              if ( !isNaN(parsed) ) {
                parsedNum = parsed;
                break;
              }
            }
          }

          if ( parsedNum !== false ) {
            page = parsedNum;
          }

          console.log(page);


          stateObj.url = url;
          stateObj.page = page;

          updateArchive();
        }
      }).on('keypress', 'a', function(e){
        e.preventDefault();
        $(this).trigger('click');
      });

      const initState = stateObj;

      window.addEventListener('popstate', function(event){
        if ( Object.keys(event.state).length == 0 ) {
          stateObj = initState;
        } else {
          stateObj = event.state;
        }

        updateArchive(true);
      });


      updateArchive = (frompopstate = false) => {
        ajaxIsLoading = true;
        $(archiveBlock).addClass('loading');
        gsap.to(window, {
          scrollTo: archiveBlock.get(0),
          duration: 0.8,
          ease: 'power1.inOut'
        });


        if ( frompopstate === false ) {
          history.pushState(stateObj, '', stateObj.url);
        }

        const args = {
          paged: stateObj.page,
          base: stateObj.base,
          sort: stateObj.sort,
          postType: stateObj.postType,
          exclude: stateObj.exclude,
          taxonomy: stateObj.taxonomy,
          term: stateObj.term,
          mode: stateObj.mode
        };

        if ( stateObj.search !== false ) {
          args.search = stateObj.search;
        } if ( stateObj.hasOwnProperty('postsPerPage') ) {
          args.postsPerPage = stateObj.postsPerPage;
        } if ( stateObj.hasOwnProperty('cardArgs') ) {
          args.cardArgs = stateObj.cardArgs;
        } if ( stateObj.hasOwnProperty('filters') && Object.keys(stateObj.filters).length ) {
          args.filters = stateObj.filters;
        }

        console.log(args);

        $.post(cat_10Vars.ajaxURL, {
          action: 'cat_10_get_archive',
          args: args
        }, function(data) {
          console.log(data);
          try {
            const res = JSON.parse(data);
            const state = Flip.getState( archiveFeed.get(0).querySelector('li') );
            $(archiveFeed).html( res.results );
            $(archivePagination).html( res.pagination );
            
            $(archivePagination).find('.pagination-container__pager').on('change', function(){
              stateObj.page = this.value;
              updateArchive();
            });

            Flip.from(state, {
              absolute: true,
              duration: 0.6,
              onEnter: elements => gsap.fromTo(elements, {opacity: 0}, {opacity: 1}),
              onLeave: elements => gsap.fromTo(elements, {opacity: 1}, {opacity: 0}),
            });
          } catch (err) {
            console.log( err );
          }
        }).always(function(){
          $(archiveBlock).removeClass('loading');
          ajaxIsLoading = false;
        });
      };
    });
  }
  /* END ARCHIVE BLOCK SCRIPTS */
}); // document ready end

/*
 * Window Resize
 ***************************/
$(window).resize(function(){

  // Run on window resize.
  updateMenuClasses();

  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
  let oldState = isMobile;
  let oldNavState = isMobileNavigationActive;
  isMobile = ( windowWidth <= mobileBreakpoint );
  isMobileNavigationActive = ( windowWidth <= navBreakpoint );
  if ( windowResizeActions.length > 0 ) {
    const updated = oldState != isMobile;
    const navUpdated = oldNavState != isMobileNavigationActive;
    for (var i = 0; i < windowResizeActions.length; i++) {
      windowResizeActions[i](updated, navUpdated);
    }
  }
  replaceHeroBgImage();
}); // end window resize functions

/*
 * Window Scroll
 ***************************/
$(window).on('scroll', function() {
  navTrigger = scrollTop;
  scrollTop = $(this).scrollTop();
}); // end window scroll functions

/*
 * Functions
 ***************************/

function updateMenuClasses() {
  $('.menu-item').each(function() {
    if ($(window).width() <= 1024) {
      $('a', this).removeClass('show_desktop_nav').addClass('show_mobile_nav');
    } else {
      $('a', this).removeClass('show_mobile_nav').addClass('show_desktop_nav');
    }
  });
}

function replaceHeroBgImage() {
  var windowWidth = $(window).width();
  $(".is-background-type-image").each(function () {
    var mobileImgSrc  = $("img", this).attr("data-mobile-src") || "";
    var tabletImgSrc  = $("img", this).attr("data-tablet-src") || "";
    var desktopImgSrc = $("img", this).attr("data-desktop-src") || "";
    if (windowWidth <= 767 && "" != mobileImgSrc) {
      $("img", this).attr("src", mobileImgSrc);
    } else if (windowWidth <= 1024 && "" != tabletImgSrc) {
      $("img", this).attr("src", tabletImgSrc);
    } else {
      if ("" != desktopImgSrc) {
        $("img", this).attr("src", desktopImgSrc);
      }
    }
  });
}

function gutenbergSlickify(el) { 
  const count = $(el).find('figure').length;
  console.log('slick Wroking');
  const captions = [];

  $(el).find('figure').each(function(){
    if ( $(this).find('figcaption').length ) {
      $(this).addClass('has-caption');
      captions.push( $(this).find('figcaption').clone(true) );
      $(this).find('figcaption').remove();
    } else {
      captions.push('<div style="height:10px;"></div>');
    }
  });

  $(el).find('.blocks-gallery-item').each(function(){
    $(this).addClass('slick-gallery-item').removeClass('blocks-gallery-item');
  });

  $(el).find('.blocks-gallery-item__caption').each(function(){
    $(this).addClass('slick-gallery-item__caption').removeClass('blocks-gallery-item__caption');
  });

  $(el).addClass('slick-gallery-grid').removeClass('blocks-gallery-grid is-layout-flex');
 
  $(el).removeClass('wp-block-gallery').wrap('<div></div>');
  const parent = $(el).parent();
  parent.addClass('slick-gallery').addClass('alignwide').removeClass('wp-block-gallery').append('<div class="slick-gallery-nav"><div class="slick-gallery-nav__inner"><div class="slick-gallery-nav__captions-outer"><div class="slick-gallery-nav__captions"></div></div></div>');
  
  console.log('hello');
  
  const nav = $(el).parent().find('.slick-gallery-nav');
  const captionsContainer = nav.find('.slick-gallery-nav__captions');
  for (let i = 0; i < captions.length; i++) {
    captionsContainer.append( captions[i] );
  }

  captionsContainer.slick({
    adaptiveHeight: true,
    arrows: false,
    swipe: false,
    fade: true
  });
  
  parent.append('<div class="slick-gallery-nav__aside"><div class="slick-gallery-nav__count"><b><span class="slick-gallery-nav__count__cur">1</span></b> of <b>' + count +'</b></div></div>');
  const navAside =  $(parent).find('.slick-gallery-nav__aside');
  
  const aside = parent.find('.slick-gallery-nav__aside');


  $(el).slick({
    adaptiveHeight: true,
    // prevArrow: prevArrow,
    // nextArrow: nextArrow,
    appendArrows: aside,
    asNavFor: captionsContainer,
  });

  $(el).on('beforeChange', function(event, slick, currentSlide, nextSlide){
    navAside.find('.slick-gallery-nav__count__cur').text(nextSlide + 1);
    nav.find('.slick-gallery-nav__count__cur').text(nextSlide + 1);
  });
}

function mapRange (value, a, b, c, d) {
  // first map value from (a..b) to (0..1)
  value = (value - a) / (b - a);
  // then map it from (0..1) to (c..d) and return it
  return c + value * (d - c);
}

function random (min, max) {
  return Math.random() * (max - min) + min;
}

function roundRandom (min, max) {
  return Math.ceil(random(min-1,max));
}

function findContainment(element, container) {

  /*
  Obtain the bounding rectangle for each element 
  */
  const brE = element.getBoundingClientRect()
  const brC = container.getBoundingClientRect()

  /* 
  If the boundaries of container pass through the boundaries of
  element then classifiy this as an overlap 
  */
  if (
    /* Does container left or right edge pass through element? */
    (brE.left < brC.left && brE.right > brC.left) ||
    (brE.left < brC.right && brE.right > brC.right) ||
    /* Does container top or bottom edge pass through element? */
    (brE.top < brC.top && brE.bottom > brC.top) ||
    (brE.top < brC.bottom && brE.bottom > brC.bottom)) {

    return "overlap";
  }

  /* 
  If boundaries of element fully contained inside bounday of
  container, classify this as containment of element in container
  */
  if (
    brE.left >= brC.left &&
    brE.top >= brC.top &&
    brE.bottom <= brC.bottom &&
    brE.right <= brC.right
  ) {
    
    return "contained"
  }

  /* 
  Otherwise, the element is fully outside the container 
  */
  return "outside"

}

function asyncTimeout(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

function addImageProcess(src){
  return new Promise((resolve, reject) => {
    try {
      let img = new Image()
      img.onload = () => {
        console.log(img);
        resolve(img.height)
      }
      img.onerror = function() {
        console.log('failed to load ' + src);
        resolve('errored');
      }
      img.src = src
    } catch(e) {
      console.log(e);
    }
    
    
  })
}

jQuery(function ($) {
	const baseFontSize = 90;
	const baseLineHeight = 78;
	const lineHeightRatio = baseLineHeight / baseFontSize; // maintain proportional ratio
	let previousWidth = $(window).width();

	const adjustHeaderFontSize = () => {
		const windowWidth = $(window).width();
		const $title = $('.post-header__title');
		const $titleHeader = $('.post-header');

		if (!$title.length || !$titleHeader.length) return;

		// Reset styles for mobile
		if (windowWidth <= 767) {
			$title.css({
				'font-size': '',
				'line-height': ''
			});
			$titleHeader.css('height', '100%');
			return;
		}

		// Clone the title element off-screen for measurement
		const $clone = $title.clone();
		$clone
			.css({
				position: 'absolute',
				visibility: 'hidden',
				height: 'auto',
				width: $title.width(),
				'font-size': `${baseFontSize}px`,
				'line-height': `${baseLineHeight}px`,
				'white-space': 'normal',
				top: '-9999px',
				left: '-9999px'
			})
			.appendTo('body');

		const cloneHeight = $clone.outerHeight();
		const lines = Math.round(cloneHeight / baseLineHeight);
		$clone.remove(); // cleanup

		let finalFontSize = baseFontSize;

		// Adjust for multi-line titles
		if (lines > 2) {
			finalFontSize = Math.max(50, baseFontSize - (lines - 2) * 6);
		}

		// ✅ Cap font size for 768px–1199px
		if (windowWidth >= 768 && windowWidth <= 1199) {
			const maxFontSize = windowWidth * 0.06; // 7vw in pixels
			if (finalFontSize > maxFontSize) {
				finalFontSize = maxFontSize;
			}
		}

		// ✅ Proportional line-height
		const finalLineHeight = finalFontSize * lineHeightRatio;

		// Apply final styles
		$title.css({
			'font-size': `${finalFontSize}px`,
			'line-height': `${finalLineHeight}px`
		});

		$titleHeader.css('height', '100%');
	};

	const initFontAdjustment = () => {
		adjustHeaderFontSize();
	};

	// Wait for fonts
	if (document.fonts && document.fonts.ready) {
		document.fonts.ready.then(initFontAdjustment);
	} else {
		$(window).on('load', initFontAdjustment);
	}

	// Resize handler
	$(window).on('resize', function () {
		const currentWidth = $(window).width();
		if (currentWidth !== previousWidth) {
			previousWidth = currentWidth;
			adjustHeaderFontSize();
		}
	});

  // Footer Navigation Mobile Accordion
  let footerAccordionWasActive = false;

  const footerNavigationMobileAccordion = () => {
    const $anchors = $('#footer-nav > .menu-item-has-children > a');
    const isAccordionActive = window.innerWidth < 768;

    if (!isAccordionActive) {
      $anchors.each(function() {
        const $anchor = $(this);
        const originalHref = $anchor.data('original-href');
        if (originalHref) {
          $anchor.attr('href', originalHref);
        }
        $anchor.removeClass('active').off('click.footerAccordion');
        $anchor.parent().children('.sub-menu').stop(true, true).removeAttr('style');
      });
      footerAccordionWasActive = false;
      return;
    }

    $anchors.each(function() {
      const $anchor = $(this);
      const $subMenu = $anchor.parent().children('.sub-menu');

      if (!$anchor.data('original-href')) {
        $anchor.data('original-href', $anchor.attr('href') || '');
      }
      this.removeAttribute('href');
      $anchor.off('click.footerAccordion').on('click.footerAccordion', function(e) {
        e.preventDefault();
        const isActive = $anchor.hasClass('active');
        if (isActive) {
          $subMenu.slideUp(200);
          $anchor.removeClass('active');
        } else {
          $subMenu.slideDown(200, function() {
            $(this).css('display', 'flex');
          });
          $anchor.addClass('active');
        }
      });
    });

    footerAccordionWasActive = true;
  };

  footerNavigationMobileAccordion();
  $(window).on('resize', footerNavigationMobileAccordion);
});
